// material-ui
import { Link, Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () => (
  <Stack direction="row" justifyContent="center" sx={{ mt: 3 }}>
    <Typography variant="subtitle2" component={Link} href="https://tlogical.com" target="_blank" underline="hover">
      &copy; 2025 COPYRIGHT THANATHAM EDUCATION CO.,LTD.
    </Typography>
  </Stack>
);

export default AuthFooter;
